<div class="detail-page-card" [formGroup]="parentForm">
    <div class="detail-page-card-title">{{ 'risk.quantitativeScoring.title' | transloco }}</div>
    <div class="detail-page-card-body padded cerrix-control-sm">
        <!-- Gross Quantitative scoring -->
        <div class="row">
            <div class="col">
                <div class="form-group">
                    <label for="grossQuantitativeImpact">{{ 'risk.quantitativeScoring.grossSingleLossExpectancy' | transloco }}</label>
                    <input
                        class="form-control form-control-sm"
                        id="grossQuantitativeImpact"
                        name="grossQuantitativeImpact"
                        type="number"
                        formControlName="grossQuantitativeImpact"
                        [placeholder]="
                            activeGrossImpactModel
                                ? activeGrossImpactModel._prettyPlaceholderText
                                : ''
                        "
                        inputTooltip
                        (keyup)="calculateGross()"
                    />
                    @if (activeGrossImpactModel) {
                        <div class="form-text" [class.red]="!grossImpactValid">
                            {{ activeGrossImpactModel._prettyRangeText }}
                        </div>
                    }
                </div>
            </div>
            <div class="col">
                <div class="form-group">
                    <label for="grossQuantitativeLikelihood">{{ 'risk.quantitativeScoring.grossLikelihoodPercent' | transloco }}</label>
                    <div class="input-group input-group-sm">
                        <input
                            class="form-control form-control-sm"
                            id="grossQuantitativeLikelihood"
                            name="grossQuantitativeLikelihood"
                            type="number"
                            formControlName="grossQuantitativeLikelihood"
                            [placeholder]="
                                activeGrossLikelihoodModel
                                    ? activeGrossLikelihoodModel._prettyPlaceholderText
                                    : ''
                            "
                            inputTooltip
                            (keyup)="calculateGross()"
                        />
                        <span class="input-group-text">%</span>
                    </div>
                    @if (activeGrossLikelihoodModel) {
                        <div class="form-text" [class.red]="!grossLikelihoodValid">
                            {{ activeGrossLikelihoodModel._prettyRangeText }}
                        </div>
                    }
                </div>
            </div>
            <div class="col">
                <div class="form-group">
                    <label>
                        {{ 'risk.quantitativeScoring.grossAnnualizedLossExpectancy' | transloco }}
                        <i
                            class="fas fa-question-circle"
                            [title]="'risk.quantitativeScoring.grossAleTooltip' | transloco"
                        ></i>
                    </label>
                    <div class="ale-value-field">
                        @if (grossAleCalculating) {
                            <span>
                                <i class="fas fa-circle-notch fa-spin"></i>
                                {{ 'risk.quantitativeScoring.calculating' | transloco }}
                            </span>
                        }
                        @if (grossAle) {
                            <span>{{ grossAle }}</span>
                        }
                    </div>
                </div>
            </div>
        </div>

        <!-- Net Quantitative scoring -->
        <div class="row mt-2">
            <div class="col">
                <div class="form-group">
                    <label for="netQuantitativeImpact">{{ 'risk.quantitativeScoring.netSingleLossExpectancy' | transloco }}</label>
                    <input
                        class="form-control form-control-sm"
                        id="netQuantitativeImpact"
                        name="netQuantitativeImpact"
                        type="number"
                        formControlName="netQuantitativeImpact"
                        [placeholder]="
                            activeNetImpactModel ? activeNetImpactModel._prettyPlaceholderText : ''
                        "
                        inputTooltip
                        (keyup)="calculateNet()"
                    />
                    @if (activeNetImpactModel) {
                        <div class="form-text" [class.red]="!netImpactValid">
                            {{ activeNetImpactModel._prettyRangeText }}
                        </div>
                    }
                </div>
            </div>
            <div class="col">
                <div class="form-group">
                    <label for="netQuantitativeLikelihood">{{ 'risk.quantitativeScoring.netLikelihoodPercent' | transloco }}</label>
                    <div class="input-group input-group-sm">
                        <input
                            class="form-control form-control-sm"
                            id="netQuantitativeLikelihood"
                            name="netQuantitativeLikelihood"
                            type="number"
                            formControlName="netQuantitativeLikelihood"
                            [placeholder]="
                                activeNetLikelihoodModel
                                    ? activeNetLikelihoodModel._prettyPlaceholderText
                                    : ''
                            "
                            inputTooltip
                            (keyup)="calculateNet()"
                        />
                        <span class="input-group-text">%</span>
                    </div>
                    @if (activeNetLikelihoodModel) {
                        <div class="form-text" [class.red]="!netLikelihoodValid">
                            {{ activeNetLikelihoodModel._prettyRangeText }}
                        </div>
                    }
                </div>
            </div>
            <div class="col">
                <div class="form-group">
                    <label>
                        {{ 'risk.quantitativeScoring.netAnnualizedLossExpectancy' | transloco }}
                        <i
                            class="fas fa-question-circle"
                            [title]="'risk.quantitativeScoring.netAleTooltip' | transloco"
                        ></i>
                    </label>
                    <div class="ale-value-field">
                        @if (netAleCalculating) {
                            <span>
                                <i class="fas fa-circle-notch fa-spin"></i>
                                {{ 'risk.quantitativeScoring.calculating' | transloco }}
                            </span>
                        }
                        @if (netAle) {
                            <span>{{ netAle }}</span>
                        }
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
